export const tagsNewOptions = [
    { value: '1', label: 'Novidade' },
    { value: '2', label: 'Nova temporada' },
    { value: '3', label: 'Novos episódios' },
    { value: '4', label: 'Em alta' }
];
